import React from "react";

export default function MSAccess_IsNumeric() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_IsNumeric</h1>
      <p>This is the MSAccess_IsNumeric component generated from the SQL JSON.</p>
    </div>
  );
}
